export enum DebtType {
  Personal = 'Personal',
  Housing = 'Housing',
  Student = 'Student',
  Car = 'Car',
  CreditCard = 'CreditCard',
  CarMCBoat = 'CarMCBoat',
  Unspecified = 'Unspecified',
  Unsecured = 'Unsecured',
  Collection = 'Collection',
}

export enum Debtor {
  MainApplicant = 'MainApplicant',
  CoApplicant = 'CoApplicant',
}

export interface Debt {
  ID: string;
  LoanApplicationID: string;
  Type: DebtType;
  OutstandingAmount?: number;
  RefinanceAmount?: number;
  Creditor?: string;
  MonthlyDebtPayment?: number;
  Source?: string;
  Debtor: Debtor;
  NominalInterestRate?: number;
}

export interface CreateDebt extends Partial<Debt> {
  LoanApplicationID: string;
}

export interface UpdateDebt extends Partial<Debt> {
  Type: DebtType;
  Debtor: Debtor;
}

export const isDebtType = (type: string): type is DebtType =>
  Object.values(DebtType).includes(type as DebtType);
